import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Drawer.css';

export default function Drawer({ open, onClose, children }) {
  // Prevent body scroll when open
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className={`drawer-content ${open ? 'open' : ''}`}>
        {children}
      </div>
    </>,
    document.body
  );
}
